// extracted by mini-css-extract-plugin
export var columnItem = "_bb-3";
export var columnItemDraggable = "_bb-4";
export var dragHandle = "_bb-0";
export var dragHandleHovered = "_bb-1";
export var dropdown = "_bb-5";
export var dropdownContent = "_bb-7";
export var dropdownInner = "_bb-6";
export var filterDropdownHeader = "_bb-8";
export var icon = "_bb-2";
export var sectionDivider = "_bb-9";